import React from "react";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faHome,
  faTasks,
  faThLarge,
  faSignOut,
  faAddressCard,
  faMoneyCheckDollar,
  faBalanceScale,
  faGavel,
} from "@fortawesome/free-solid-svg-icons";

//hooks
import useAuth from "./../../hooks/useAuth";
import Swal from "sweetalert2";
import { dispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { allScores, getLoanList, pendingSteps } from "../../redux/slices/loan";
import { useEffect } from "react";

// ----------------------------------------------------------------------

export default function Header() {
  const { isAuthenticated, user, logout } = useAuth();
  const { scoreData, loanList, checkSteps } = useSelector(
    (state) => state.loan
  );
  let navigate = useNavigate();
  const location = useLocation();
  let dispatch = useDispatch();

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger mx-2",
      confirmButton: "btn btn-primary mx-2",
    },
    buttonsStyling: false,
  });
  const handleLogout = async () => {
    await logout();
    // Swal.fire({
    //   text: "Logged out successfully!",
    //   icon: "success",
    // });
    navigate("/auth/login");
    window.location.reload();
  };
  // const handleNavigate = () => {
  //   dispatch(allScores());
  //   // navigate("/cibil-score");
  //   if (
  //     scoreData !== null &&
  //     scoreData !== undefined &&
  //     scoreData !== "" &&
  //     scoreData?.success === false
  //   ) {
  //     Swal.fire({
  //       icon: "warning",
  //       text: `Your loan application is under review.`,
  //     });
  //     // navigate("/dashboard");
  //   } else {
  //     navigate("/cibil-score");
  //   }
  // };

  useEffect(() => {
    dispatch(pendingSteps());
    // dispatch(allScores());
    dispatch(getLoanList());
  }, []);

  return (
    <>
      <div className="col-sm-12 col-md-12 col-lg-3">
        <div className="sidebar mb-4">
          <ul className="nav flex-column" id="nav_accordion">
            {user?.user_type === "2" ? (
              <>
                <li
                  className={
                    location.pathname === "/supplier"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/supplier"
                    className={
                      location.pathname === "/supplier"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faHome} className="me-2" />
                    Dashboard
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname.includes("onboarding")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/supplier/onboarding/basic-info"
                    className={
                      location.pathname.includes("onboarding")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faTasks} className="me-2" />
                    On Boarding
                  </RouterLink>
                </li>
                {user?.onboarding && (
                  <li
                    className={
                      location.pathname.includes("products") ||
                      location.pathname.includes("inventories")
                        ? "nav-item has-submenu active"
                        : "nav-item has-submenu"
                    }
                  >
                    <a
                      className="nav-link menu-link"
                      data-bs-toggle="collapse"
                      href="#collapseProduct"
                      aria-expanded="false"
                    >
                      <FontAwesomeIcon icon={faThLarge} className="me-2" />
                      Products{" "}
                    </a>
                    <ul
                      className="submenu collapse"
                      id="collapseProduct"
                      data-parent="#nav_accordion"
                    >
                      <li
                        className={
                          location.pathname === "/supplier/products"
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/supplier/products"
                          className="nav-link"
                        >
                          Products
                        </RouterLink>
                      </li>
                      <li
                        className={
                          location.pathname === "/supplier/inventories"
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/supplier/inventories"
                          className="nav-link"
                        >
                          Inventories
                        </RouterLink>
                      </li>
                      {/* <li
                        className={
                          location.pathname === "/supplier/products/add"
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/supplier/products/add"
                          className="nav-link"
                        >
                          Add Product
                        </RouterLink>
                      </li> */}
                      <li
                        className={
                          location.pathname === "/supplier/products/new"
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/supplier/products/new"
                          className="nav-link"
                        >
                          Add Product
                        </RouterLink>
                      </li>
                    </ul>
                  </li>
                )}
                <li
                  className={
                    location.pathname === "/supplier/quotations"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/supplier/quotations"
                    className={
                      location.pathname === "/supplier/quotations"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faGavel} className="me-2" />{" "}
                    Quotations{" "}
                  </RouterLink>
                </li>
                {/* <li
                  className={
                    location.pathname.includes("balancesheet")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/supplier/balancesheet"
                    className={
                      location.pathname.includes("balancesheet")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faBalanceScale} className="me-2" />
                    Balance Sheet
                  </RouterLink>
                </li> */}
                {/* <li
                  className={
                    location.pathname.includes("incomestatement")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/supplier/incomestatement"
                    className={
                      location.pathname.includes("incomestatement")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon
                      icon={faMoneyCheckDollar}
                      className="me-2"
                    />
                    Income Statement
                  </RouterLink>
                </li> */}
                <li
                  className={
                    location.pathname === "/supplier/orders"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/supplier/orders"
                    className={
                      location.pathname === "/supplier/orders"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="fas fa-shopping-cart me-2"></i> Orders
                  </RouterLink>
                </li>
                {user?.onboarding && (
                  <li
                    className={
                      location.pathname.includes("/loanprocess") ||
                      location.pathname.includes("/supplier/list-loans")
                        ? "nav-item has-submenu active"
                        : "nav-item has-submenu"
                    }
                  >
                    <a
                      className="nav-link menu-link"
                      data-bs-toggle="collapse"
                      href="#collapseLoans"
                      aria-expanded="false"
                    >
                      <i className="fas fa-landmark me-2"></i> Loans{" "}
                    </a>
                    <ul
                      className="submenu collapse"
                      id="collapseLoans"
                      data-parent="#nav_accordion"
                    >
                      <li
                        className={
                          location.pathname.includes("/supplier/list-loans")
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/supplier/list-loans"
                          className={
                            location.pathname.includes("/supplier/list-loans")
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          List of Loans
                        </RouterLink>
                      </li>

                      <li
                        className={
                          location.pathname.includes("/loanprocess")
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/loanprocess"
                          className={
                            location.pathname.includes("/loanprocess")
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          Apply for Loan
                        </RouterLink>
                      </li>
                      {/* {checkSteps?.loan_status === "rejected" ||checkSteps?.loan_status === "accepted" && (
                      <li
                        className={
                          location.pathname.includes("")
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to=""
                          className={
                            location.pathname.includes("")
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          Apply for Loan
                        </RouterLink>
                      </li>
                    )} */}
                    </ul>
                  </li>
                )}
              </>
            ) : user?.user_type === "4" ? (
              <>
                <li
                  className={
                    location.pathname === "/financer"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/financer"
                    className={
                      location.pathname === "/financer"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faHome} className="me-2" />
                    Dashboard
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname === "/financer/address"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/financer/address"
                    className={
                      location.pathname === "/financer/address"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faAddressCard} className="me-2" />
                    Address
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname === "/financer/loan-qualification"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/financer/loan-qualification"
                    className={
                      location.pathname === "/financer/loan-qualification"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="fas fa-book me-2"></i>
                    Loan Qualification
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname === "/financer/profile"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/financer/profile"
                    className={
                      location.pathname === "/financer/profile"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faGavel} className="me-2" />
                    Profile
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname.includes("/financer/loan-offers")
                      ? "nav-item has-submenu active"
                      : "nav-item has-submenu"
                  }
                >
                  <a
                    className="nav-link menu-link"
                    data-bs-toggle="collapse"
                    href="#collapseCustLoans"
                    aria-expanded="false"
                  >
                    <i className="fas fa-landmark"></i> Loan Offers{" "}
                  </a>
                  <ul
                    className="submenu collapse"
                    id="collapseCustLoans"
                    data-parent="#nav_accordion"
                  >
                    <li
                      className={
                        location.pathname.includes("/financer/loan-offers")
                          ? "active"
                          : ""
                      }
                    >
                      <RouterLink
                        to="/financer/loan-offers"
                        className={
                          location.pathname.includes("/financer/loan-offers")
                            ? "nav-link active"
                            : "nav-link"
                        }
                      >
                        Manage Offers
                      </RouterLink>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <li
                  className={
                    location.pathname === "/dashboard"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/dashboard"
                    className={
                      location.pathname === "/dashboard"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faHome} className="me-2" />
                    Dashboard
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname === "/user/address"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/user/address"
                    className={
                      location.pathname === "/user/address"
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faAddressCard} className="me-2" />
                    Address
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname.includes("my-quotations")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/user/my-quotations"
                    className={
                      location.pathname.includes("my-quotations")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <FontAwesomeIcon icon={faGavel} className="me-2" />
                    My Quotations
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname.includes("orders")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/user/orders"
                    className={
                      location.pathname.includes("orders")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="fas fa-shopping-cart me-2"> </i>Orders
                  </RouterLink>
                </li>
                <li
                  className={
                    location.pathname.includes("wishlist")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <RouterLink
                    to="/user/wishlist"
                    className={
                      location.pathname.includes("wishlist")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="fas fa-heart me-2"> </i>Wishlist
                  </RouterLink>
                </li>
                {(user?.onboarding || user?.user_type === "3") && (
                  <li
                    className={
                      location.pathname.includes("/loanprocess") ||
                      location.pathname.includes("/user/list-loans")
                        ? "nav-item has-submenu active"
                        : "nav-item has-submenu"
                    }
                  >
                    <a
                      className="nav-link menu-link"
                      data-bs-toggle="collapse"
                      href="#collapseCustLoans"
                      aria-expanded="false"
                    >
                      <i className="fas fa-landmark me-2"></i>Loans{" "}
                    </a>
                    <ul
                      className="submenu collapse"
                      id="collapseCustLoans"
                      data-parent="#nav_accordion"
                    >
                      <li
                        className={
                          location.pathname.includes("/user/list-loans")
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/user/list-loans"
                          className={
                            location.pathname.includes("/user/list-loans")
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          List of Loans
                        </RouterLink>
                      </li>
                      <li
                        className={
                          location.pathname.includes("/loanprocess")
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to="/loanprocess"
                          className={
                            location.pathname.includes("/loanprocess")
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          Apply for Loan
                        </RouterLink>
                      </li>
                      {/* {scoreData?.loan_status === "no" && (
                      <li
                        className={
                          location.pathname.includes("")
                            ? "active"
                            : ""
                        }
                      >
                        <RouterLink
                          to=""
                          className={
                            location.pathname.includes("")
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          Apply for Loan
                        </RouterLink>
                      </li>
                    )} */}
                    </ul>
                  </li>
                )}
              </>
            )}

            {/* <li
              className={
                location.pathname.includes("change-password")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <RouterLink
                to="/user/change-password"
                className={
                  location.pathname.includes("change-password")
                    ? "nav-link active"
                    : "nav-link"
                }
              >
                <FontAwesomeIcon icon={faGear} className="me-2" /> Settings
              </RouterLink>
            </li> */}
            <li
              className={
                location.pathname.includes("/user/profile/edit") ||
                location.pathname.includes("/financer/profile/edit") ||
                location.pathname.includes("/user/change-password")
                  ? "nav-item has-submenu active"
                  : "nav-item has-submenu"
              }
            >
              <a
                className="nav-link menu-link"
                data-bs-toggle="collapse"
                href="#collapseSettings"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faGear} className="me-2" />
                Settings{" "}
              </a>
              <ul
                className="submenu collapse"
                id="collapseSettings"
                data-parent="#nav_accordion"
              >
                {/* {user.user_type === "4" ? (
                  <li
                    className={
                      location.pathname.includes("/financer/profile/edit")
                        ? "active"
                        : ""
                    }
                  >
                    <RouterLink
                      to="/financer/profile/edit"
                      className={
                        location.pathname.includes("/financer/profile/edit")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      Edit Profile
                    </RouterLink>
                  </li>
                ) : (
                  <li
                    className={
                      location.pathname.includes("/user/profile/edit")
                        ? "active"
                        : ""
                    }
                  >
                    <RouterLink
                      to="/user/profile/edit"
                      className={
                        location.pathname.includes("/user/profile/edit")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      Edit Profile
                    </RouterLink>
                  </li>
                )} */}

                <li
                  className={
                    location.pathname.includes("/user/change-password")
                      ? "active"
                      : ""
                  }
                >
                  <RouterLink
                    to="/user/change-password"
                    className={
                      location.pathname.includes("/user/change-password")
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    Change Password
                  </RouterLink>
                </li>

                {user?.user_type !== "4" && (
                  <li
                    className={
                      location.pathname.includes("/user/edit-business")
                        ? "active"
                        : ""
                    }
                  >
                    <RouterLink
                      to="/user/edit-business"
                      className={
                        location.pathname.includes("/user/edit-business")
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      Business
                    </RouterLink>
                  </li>
                )}
              </ul>
            </li>

            {/* {(user.user_type === "2" || user.user_type === "3") &&
            scoreData?.loan_applied ? (
              <>
                {" "}
                <li className="nav-item" onClick={handleNavigate}>
                  <RouterLink className="nav-link">
                    <FontAwesomeIcon
                      icon={faMoneyCheckDollar}
                      className="me-2"
                    />
                    Loan Scorecard
                  </RouterLink>
                </li>
              </>
            ) : null} */}

            {isAuthenticated ? (
              <li className="nav-item">
                <RouterLink
                  className="nav-link"
                  to="/#!"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <FontAwesomeIcon icon={faSignOut} className="me-2" />
                  Logout
                </RouterLink>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </>
  );
}
